import {infiniteQueryOptions, keepPreviousData} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {NutritionPlansDependencies} from '../dependencies';
import {keys} from './keys';

export type ListNutritionPlansQueryDependencies = Pick<NutritionPlansDependencies, 'controllers'>;

export const listNutritionPlansQuery = (
  {controllers}: ListNutritionPlansQueryDependencies,
  q = '',
) =>
  infiniteQueryOptions({
    queryKey: [...keys.list(), q] as const,
    queryFn: ({pageParam}) =>
      controllers.nutritionPlanController.list({cursor: pageParam, q}).then(unwrap),
    initialPageParam: null as string | null,
    getNextPageParam: lastPage => lastPage.nextCursor ?? undefined,
    placeholderData: keepPreviousData,
  });
